export const controleTitulosStyles = {}
